import * as Yup from "yup";

export const dataModel = {
  year: "",
  month: "",
  addDelay: false,
  addExtra: false,
};

export const validationDataModel = () => {
  return Yup.object().shape({
    year: Yup.number().required("forms.validations.required"),
    month: Yup.number().required("forms.validations.required"),
    addDelay: Yup.boolean().optional("forms.validations.required"),
    addExtra: Yup.boolean().optional("forms.validations.required"),
  });
};

export const setInitialValues = (initialValues) => {
  const newValues = { ...dataModel };
  if (initialValues) {
    const items = Object.keys(newValues);
    items.forEach((item) => {
      if (initialValues[item]) {
        newValues[item] = initialValues[item];
      }
    });
    return newValues;
  }

  return dataModel;
};
